import { useCallback, useMemo, useSyncExternalStore } from 'react';

import {
  type AiFieldCellRequestState,
  type AiFieldCellRequestTarget
} from './ai-field-cell-request-coordinator';
import { aiFieldCellRequestCoordinator } from './ai-field-cell-request-store';

export const useAiFieldCellRequestState = (
  target: AiFieldCellRequestTarget
): AiFieldCellRequestState => {
  const { aiFieldType, contentId, entryId, fieldId } = target;
  const requestTarget = useMemo(
    () => ({ aiFieldType, contentId, entryId, fieldId }),
    [aiFieldType, contentId, entryId, fieldId]
  );
  const subscribe = useCallback(
    (listener: () => void) =>
      aiFieldCellRequestCoordinator.subscribe(requestTarget, listener),
    [requestTarget]
  );
  const getSnapshot = useCallback(
    () => aiFieldCellRequestCoordinator.getRequestState(requestTarget),
    [requestTarget]
  );

  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
};
